import React from 'react'
import ScrollToTop from './ScrollToTop';
import { BrowserRouter as Router, Routes as Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AppLinkFallbackPage from './pages/AppLinkFallbackPage';

const Routes = () => {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/" element={<Home />} />
        <Route path="/dl/club/:clubId" element={<AppLinkFallbackPage />} />
        <Route path="/dl/event/:eventId/:eventSessionId" element={<AppLinkFallbackPage />} />
      </Switch>
    </Router>
  )
}

export default Routes